module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hd-wap-help"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("1.无法登录怎么办？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "f12"
  }, [_vm._v("(1) 退出APP，关闭所有进程，再重新登录")]), _vm._v(" "), _c('p', {
    staticClass: "f12"
  }, [_vm._v("(2) 卸载当前APP，安装最新版本")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("2.找不到之前的学习记录怎么办？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "f12"
  }, [_vm._v("当前登录帐号不是购课时的帐号：例如购课时是手机验证码登录的，但查看时用第三方授权登录。建议固定登录方式后，无特殊情况，不要随意变更。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("3.错过免费直播怎么办？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "f12"
  }, [_vm._v("如无法观看免费直播，可以在直播历史栏目中支付积分后查看对应录播，需要在课程有效期前，有效期后录播自动下架，无法恢复，请您谅解。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("4.课程视频无法打开怎么办？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "f12"
  }, [_vm._v("抱歉给您带来麻烦，建议卸载，安装最新版本，在网络良好的情况下重新登录打开对应课程视频。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("5.ios设备，没法连接网络，怎么解决？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "f12"
  }, [_vm._v("从设置-无线局域网-使用无线局域网与蜂窝移动的应用-找到“海渡职校”，开启无线局域网与蜂窝移动。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("6.有开发pc或mac版本计划么？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "f12"
  }, [_vm._v("pc版官网地址为："), _c('a', {
    attrs: {
      "href": "http://www.edubotcoll.com"
    }
  }, [_vm._v("www.edubotcoll.com")]), _vm._v(" ，即将上线更多功能，谢谢关注和支持。")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("7.有职校讲师招募计划么？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "f12"
  }, [_vm._v("海渡职校欢迎社会各界关注工业机器人教育的小伙伴加入共建计划，入驻讲师及机构会获得对应订阅学员的学费回馈，详情欢迎登陆职校官网"), _c('a', {
    attrs: {
      "href": "http://www.edubotcoll.com"
    }
  }, [_vm._v("www.edubotcoll.com")]), _vm._v("查看。")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02dcfaf2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help.vue
// module id = 313
// module chunks = 1